import {useLazySourcingGetCarFeaturesQuery} from '@dms/api/core';

import {parseDate} from 'shared/web';

import {BaseVehicle} from '../../core/types/BaseVehicle';

/**
 * Fetches sourcing data for feature highlighting and premium detection
 */
export function useGetCarFeatures() {
  const [getSourcingFeatures, data] = useLazySourcingGetCarFeaturesQuery();

  const getCarFeatures = async (formData: BaseVehicle) => {
    if (!formData.make || !formData.modelFamily || !formData.firstRegistrationOn) {
      return null;
    }

    try {
      const {data: sourcingFeatures} = await getSourcingFeatures({
        body: {
          make: formData.make,
          model: formData.modelFamily,
          year: parseDate(formData.firstRegistrationOn)?.getFullYear() || 0,
          features: formData.features || [],
        },
      });

      return sourcingFeatures;
    } catch (error) {
      console.warn('Failed to fetch sourcing features:', error);
      return null;
    }
  };

  return [getCarFeatures, data] as const;
}
